export const HEADER_FAVORITES_ELEMENT_ID = 'header-favorites'
export const FAVORITE_LINK_ID = 'favorite-link'
export const FAVORITE_LINK_HEART_ID = 'favorite-link-heart'
export const NO_RESULTS_TITLE = 'Nothing is here'
export const NO_RESULTS_TEXT = 'Make sure the url is correct or try to reload the page.'
export const EMPTY_LIST_TEXT = 'Explore our products and add your favorites anywhere you see a heart.'
